import z from "zod";

export const getServiceFulfillmentPartnerSchema = z.object({
	serviceId: z.string(),
	contactId: z.string(),
});

export type GetServiceFulfillmentPartnerSchema = z.infer<typeof getServiceFulfillmentPartnerSchema>;
